import { useEffect, useState } from 'react';
import type { Comic } from '@/mocks/manga';
import { comics, faqs } from '@/mocks/manga';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import HotComics from './components/HotComics';
import FeaturedTopic from './components/FeaturedTopic';
import FAQ from './components/FAQ';
import About from './components/About';
import Footer from './components/Footer';
import ComicDetailModal from './components/ComicDetailModal';

export default function Home() {
  const [filter, setFilter] = useState('全部');
  const [selected, setSelected] = useState<Comic | null>(null);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleCategorySelect = (key: string) => {
    setFilter(key);
    const el = document.getElementById('hot');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  const itemListLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '热门女神系漫画推荐',
    itemListElement: comics.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.title,
      url: `https://serieslog.github.io/#hot`,
      description: c.desc,
    })),
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories onSelect={handleCategorySelect} />
        <HotComics filter={filter} onChangeFilter={setFilter} onOpen={setSelected} />
        <FeaturedTopic />
        <FAQ />
        <About />
      </main>
      <Footer />
      <ComicDetailModal comic={selected} onClose={() => setSelected(null)} />

      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-50 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition-all hover:bg-primary-600 ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line text-xl" />
      </button>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListLd) }}
      />
    </>
  );
}